import { css, DefaultTheme, FlattenInterpolation, ThemeProps } from 'styled-components';

import { ColorType } from 'shared/tag/CoreTag';

const primary = css`
	background-color: ${(props) => props.theme.colors.uplus.primary50_key};
	color: ${(props) => props.theme.colors.gray.gray_white};
	& > div > span > svg {
		fill: ${(props) => props.theme.colors.gray.gray_white};
	}
`;

const secondary = css`
	background-color: ${(props) => props.theme.colors.uplus.primary10_lighten};
	color: ${(props) => props.theme.colors.uplus.primary80_darken};
	& > div > span > svg {
		fill: ${(props) => props.theme.colors.uplus.primary80_darken};
	}
`;

const black = css`
	background-color: ${(props) => props.theme.colors.gray.gray80_text};
	color: ${(props) => props.theme.colors.gray.gray_white};
	& > div > span > svg {
		fill: ${(props) => props.theme.colors.gray.gray_white};
	}
`;

const gray = css`
	background-color: ${(props) => props.theme.colors.gray.gray15};
	color: ${(props) => props.theme.colors.gray.gray80_text};
	& > div > span > svg {
		fill: ${(props) => props.theme.colors.gray.gray80_text};
	}
`;

const red = css`
	background-color: ${(props) => props.theme.colors.system.red_lighten};
	color: ${(props) => props.theme.colors.system.red_darken};
	& > div > span > svg {
		fill: ${(props) => props.theme.colors.system.red_darken};
	}
`;

const yellow = css`
	background-color: ${(props) => props.theme.colors.system.yellow_lighten};
	color: ${(props) => props.theme.colors.system.yellow_darken};
	& > div > span > svg {
		fill: ${(props) => props.theme.colors.system.yellow_darken};
	}
`;

const green = css`
	background-color: ${(props) => props.theme.colors.system.green_lighten};
	color: ${(props) => props.theme.colors.system.green_darken};
	& > div > span > svg {
		fill: ${(props) => props.theme.colors.system.green_darken};
	}
`;

const blue = css`
	background-color: ${(props) => props.theme.colors.system.blue_lighten};
	color: ${(props) => props.theme.colors.system.blue_darken};
	& > div > span > svg {
		fill: ${(props) => props.theme.colors.system.blue_darken};
	}
`;

interface ITagColorType {
	primary: FlattenInterpolation<ThemeProps<DefaultTheme>>;
	secondary: FlattenInterpolation<ThemeProps<DefaultTheme>>;
	black: FlattenInterpolation<ThemeProps<DefaultTheme>>;
	gray: FlattenInterpolation<ThemeProps<DefaultTheme>>;
	red: FlattenInterpolation<ThemeProps<DefaultTheme>>;
	yellow: FlattenInterpolation<ThemeProps<DefaultTheme>>;
	green: FlattenInterpolation<ThemeProps<DefaultTheme>>;
	blue: FlattenInterpolation<ThemeProps<DefaultTheme>>;
}

export const tagColorType: ITagColorType = {
	primary,
	secondary,
	black,
	gray,
	red,
	yellow,
	green,
	blue,
};

export const setColorByChar = (name: string): ColorType => {
	const target = name.charCodeAt(0);

	if (target % 5 === 0) {
		return 'blue';
	} else if (target % 5 === 1) {
		return 'green';
	} else if (target % 5 === 2) {
		return 'red';
	} else if (target % 5 === 3) {
		return 'yellow';
	} else if (target % 5 === 4) {
		return 'secondary';
	} else return 'yellow';
};

const getTotalCharCode = (text: string) => {
	return text.split('').reduce((acc, cur) => acc + cur.charCodeAt(0), 0);
};

/**
 * 구 디자인 시스템의 태그 컬러를 카테고리 명 기반으로 반환합니다.
 */
export const setCategoryColor = (name?: string) => {
	if (!name) return 'blue';
	const charCode = getTotalCharCode(name);
	const idx = charCode % 4;
	if (idx === 0) {
		return 'yellow';
	} else if (idx === 1) {
		return 'blue';
	} else if (idx === 2) {
		return 'green';
	} else if (idx === 3) {
		return 'red';
	} else return 'blue';
};
